import { render, staticRenderFns } from "./pondFeeding.vue?vue&type=template&id=ea13dae0&"
import script from "./pondFeeding.vue?vue&type=script&lang=js&"
export * from "./pondFeeding.vue?vue&type=script&lang=js&"
import style0 from "./pondFeeding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports